'use client';

import { c as _c } from "react/compiler-runtime";
import { ClipboardList, LifeBuoy, Rocket, Search, type LucideIcon } from 'lucide-react';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { Container, Section, SectionHeader, Card, MotionBlock } from './shared';
import { HowItWorksRolloutChart } from './HowItWorksRolloutChart';
import { cn } from '@/lib/utils';
const stepIcons: LucideIcon[] = [Search, ClipboardList, Rocket, LifeBuoy];
export function HowItWorks() {
  const $ = _c(15);
  const c = useCadrinoCopy();
  const steps = c.howItWorks.steps;
  let t0;
  if ($[0] !== c.howItWorks.subtitle || $[1] !== c.howItWorks.title) {
    t0 = <SectionHeader title={c.howItWorks.title} subtitle={c.howItWorks.subtitle} />;
    $[0] = c.howItWorks.subtitle;
    $[1] = c.howItWorks.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HowItWorksRolloutChart />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <MotionBlock className="lg:sticky lg:top-28">{t0}{t1}</MotionBlock>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== steps) {
    let t4;
    if ($[8] !== steps.length) {
      t4 = (step, i) => {
        const Icon = stepIcons[i] ?? Search;
        const isLast = i === steps.length - 1;
        return <MotionBlock key={step.title} delay={i * 0.06} className="relative"><li className="relative flex gap-5 sm:gap-6">{!isLast && <span className="absolute left-[1.375rem] top-14 bottom-0 w-px bg-gradient-to-b from-cadrino-primary/35 via-slate-200 to-transparent sm:left-6" aria-hidden={true} />}<div className="relative z-10 flex shrink-0 flex-col items-center"><div className={cn("flex h-11 w-11 items-center justify-center rounded-full border-2 border-white", "bg-cadrino-primary text-white shadow-md shadow-cadrino-primary/20", "ring-4 ring-cadrino-primary/10 sm:h-12 sm:w-12")}><Icon className="h-5 w-5" aria-hidden={true} /></div><span className="mt-2 text-[10px] font-semibold uppercase tracking-wider text-slate-400">{String(i + 1).padStart(2, "0")}</span></div><Card className="min-w-0 flex-1 border-slate-200/90 p-5 shadow-sm transition-shadow hover:shadow-md sm:p-6"><span className="inline-flex rounded-full border border-cadrino-accent/25 bg-cadrino-accent/5 px-2.5 py-0.5 text-xs font-medium text-cadrino-accent">{step.time}</span><h3 className="mt-2.5 text-base font-semibold leading-snug text-slate-900 sm:text-lg">{step.title}</h3><p className="mt-2 text-sm leading-relaxed text-cadrino-muted">{step.description}</p></Card></li></MotionBlock>;
      };
      $[8] = steps.length;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = steps.map(t4);
    $[6] = steps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <ol className="relative mt-10 space-y-5 lg:mt-0">{t3}</ol>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t4) {
    t5 = <Section id="how" className="border-y border-slate-200/80 bg-gradient-to-b from-slate-50/50 via-white to-white"><Container><div className="lg:grid lg:grid-cols-[minmax(0,22rem)_1fr] lg:items-start lg:gap-16 xl:gap-20">{t2}{t4}</div></Container></Section>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}